// Importaciones de interfaces.
import { IEmployee } from '../interfaces/employee.interface';
import { ILog } from '../interfaces/log.interface';

// Importaciones de modelos.
import { Employee } from './employee.model';

export class Log implements ILog {
  /*
   * El identificador único del registro.
   * Puede ser `null` si no se ha asignado aún.
   */
  id: number | null;

  /*
   * El objeto que contiene la información del empleado
   * asociado al registro.
   */
  employee: IEmployee;

  /*
   * La dirección IP desde la que se realizó el acceso.
   * Puede ser `null` si no está disponible.
   */
  ipAddress: string | null;

  /*
   * Información sobre el navegador o dispositivo utilizado para acceder.
   * Puede ser `null` si no se proporciona.
   */
  userAgent: string | null;

  /*
   * Descripción del acceso o evento registrado.
   * Puede ser `null` si no se especifica.
   */
  description: string | null;

  /*
   * La fecha de la última actualización del registro.
   * Puede ser `null` si el registro aún no ha sido actualizado.
   */
  updatedAt: string | null;

  /*
   * La fecha de creación del registro.
   * Puede ser `null` si el registro aún no ha sido creado o registrado.
   */
  createdAt: string | null;

  /**
   * Constructor de la clase que inicializa una instancia de ILog.
   *
   * @param {Partial<ILog>} log - Un objeto parcial de ILog que contiene las siguientes propiedades opcionales:
   *   - `id` (opcional): Identificador único del registro. Por defecto, `null`.
   *   - `employee` (opcional): Objeto que contiene la información del empleado asociado al registro. Por defecto, se crea una nueva instancia de `Employee`.
   *   - `ipAddress` (opcional): Dirección IP desde la que se realizó el acceso. Por defecto, `null`.
   *   - `userAgent` (opcional): Información sobre el navegador o dispositivo utilizado para acceder. Por defecto, `null`.
   *   - `description` (opcional): Descripción del acceso o evento registrado. Por defecto, `null`.
   *   - `updatedAt` (opcional): Fecha de la última actualización del registro. Por defecto, `null`.
   *   - `createdAt` (opcional): Fecha de creación del registro. Por defecto, `null`.
   */
  constructor({
    id = null,
    employee = new Employee(),
    ipAddress = null,
    userAgent = null,
    description = null,
    updatedAt = null,
    createdAt = null,
  }: Partial<ILog> = {}) {
    this.id = id;
    this.employee = employee;
    this.ipAddress = ipAddress;
    this.userAgent = userAgent;
    this.description = description;
    this.updatedAt = updatedAt;
    this.createdAt = createdAt;
  }
}
